<template>
    <div class="switcher">
        <strong>{{ $t('main_language') }}</strong>
        <ul>
            <li v-for="lang in languages" :key="lang.id" :class="{ active: lang.id === language }" @click="changeLanguage(lang.id)">
                <a class="lang-button" href="javascript:void(0)" :title="lang.languagename">{{lang.id}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as qs from 'qs'
import { API } from '../../api/axios'
import de from 'vee-validate/dist/locale/de'
import en from 'vee-validate/dist/locale/en'
import es from 'vee-validate/dist/locale/es'
import fr from 'vee-validate/dist/locale/fr'
import nl from 'vee-validate/dist/locale/nl'

export default {
  name: 'LanguageSelector',
  computed: {
    ...mapGetters(['languages', 'language', 'user']),
    vee_languages () {
      // @TODO: hard-coded languages -> dynamic (eg. axios get from API at start)
      return {de, en, es, fr, nl}
    },
  },
  methods: {
    updateUser (newLanguageId) {
      let querystring = qs.stringify({
        preferredlanguage: newLanguageId,
        firstname: this.user.firstname,
        middlename: this.user.middlename,
        lastname: this.user.lastname,
        licenseplate: this.user.licenseplate,
      })
      return API.put(`/users/${this.user.id}?${querystring}`)
    },
    changeLanguage (newLanguageId) {
      let change = () => {
        let current = {
          name: this.$route.name,
          params: this.$route.params,
          query: this.$route.query,
        }
        current.params.lang = newLanguageId

        this.$router.replace(current)
        this.$store.commit('changeLanguage', newLanguageId)
        this.$validator.localize(this.language, this.vee_languages[this.language])
      }

      if (this.user.id) {
        this.updateUser(newLanguageId)
          .then(() => {
            change()
          })
          .catch(error => {
            console.log('Error updating language', error)
          })
      } else {
        change()
      }
    },
  },
}
</script>

<style scoped>

  .lang-button {
    font-size: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/utilities/LanguageSelector.vue